import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useLingui } from '@lingui/react';
import * as React from 'react';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { brandSchema, marketSchema } from 'data/schema';
import { user } from 'utils/auth/user';
import { getLocale } from 'i18n/locale';
import { getLegalDocuments, LegalDocuments } from 'utils/network/legal';
import { IShowroomProps } from 'components/Showroom';
import Wltp from './Wltp';

export interface IFooterProps {
  withoutWltp?: boolean;
  userType?: IShowroomProps['userType'];
}

const Footer: React.FC<IFooterProps> = ({ withoutWltp, userType = user.type }) => {
  const { _ } = useLingui();
  const [legalDocs, setLegalDocs] = React.useState<LegalDocuments>({});
  tenantConfig().useState();
  const session = userSession().useState();
  const brand = brandSchema.parse(session?.brand || user.brand);
  const market = marketSchema.parse(session?.market || user.market.iso3);
  const locale = session?.locale || getLocale(market);
  const imprintRoute = { dealer: `/${brand}/${market}/legal/imprint`, customer: `/${brand}/${market}/imprint` };
  const privacyRoute = {
    dealer: `/${brand}/${market}/legal/privacy-policy`,
    customer: `/${brand}/${market}/legal`,
  };

  React.useEffect(() => {
    (async () => {
      if (brand && market && locale) {
        const legalDocuments = await getLegalDocuments(brand, market, locale);
        setLegalDocs(legalDocuments[userType]);
      }
    })();
  }, [brand, market, locale, userType]);

  return (
    <>
      <footer className="ex3d-streaming-footer" part="footer">
        {!withoutWltp && <Wltp />}
        <div className="ex3d-legal-container">
          <span id="copyright" className="whitespace-nowrap pl-2">{`© ${new Date().getFullYear()} ${_(
            t({
              context: 'multibrand',
              message: `Volkswagen Group.`,
            })
          )} ${_(
            t({
              context: 'multibrand',
              message: `All rights reserved`,
            })
          )}`}</span>
          {Object.values(legalDocs).some((val) => Boolean(val)) && (
            <ul className="flex gap-x-4">
              {legalDocs.imprint && (
                <li>
                  <a href={imprintRoute[userType]} target="_blank" className="hover:underline" rel="noreferrer">
                    <Trans>Imprint</Trans>
                  </a>
                </li>
              )}
              {(legalDocs.privacyPolicy || legalDocs.termsOfUse) && (
                <li>
                  <a href={privacyRoute[userType]} target="_blank" className="hover:underline" rel="noreferrer">
                    <Trans>Privacy Policy</Trans>
                  </a>
                </li>
              )}
            </ul>
          )}
        </div>
      </footer>
    </>
  );
};

export default Footer;
